// Shared styles
import '../css/tailwind.css';

// Import all images from src/images directory
function importAll(r) {
  return r.keys().map(r);
}
importAll(require.context('../images', false, /\.(png|jpe?g|svg|gif)$/));

// Alpine.js
import Alpine from 'alpinejs';
window.Alpine = Alpine;
Alpine.start();

// Navigation interactions
const mobileMenuToggle = document.querySelector('[data-mobile-menu-toggle]');
const mobileMenu = document.querySelector('[data-mobile-menu]');

if (mobileMenuToggle && mobileMenu) {
  mobileMenuToggle.addEventListener('click', () => {
    const isOpen = mobileMenu.classList.toggle('is-open');
    mobileMenuToggle.setAttribute('aria-expanded', String(isOpen));
  });
}

const dropdownTriggers = document.querySelectorAll('[data-dropdown-trigger]');

// The dropdown menu lives as a sibling of the trigger's wrapper inside the parent <li>.
const getMenuForTrigger = (trigger) => {
  const container = trigger.closest('li') || trigger.parentElement;
  return container ? container.querySelector('[data-dropdown-menu]') : null;
};

const closeAllDropdowns = (exception = null) => {
  dropdownTriggers.forEach((trigger) => {
    if (trigger !== exception) {
      trigger.setAttribute('aria-expanded', 'false');
      const menu = getMenuForTrigger(trigger);
      if (menu && menu.matches('[data-dropdown-menu]')) {
        menu.classList.add('opacity-0', 'invisible', 'translate-y-1', 'pointer-events-none');
        menu.classList.remove('opacity-100', 'visible', 'translate-y-0', 'pointer-events-auto');
      }
    }
  });
};



if (dropdownTriggers.length) {
  dropdownTriggers.forEach((trigger) => {
    trigger.addEventListener('click', (event) => {
      event.stopPropagation();
      const menu = getMenuForTrigger(trigger);
      if (!menu || !menu.matches('[data-dropdown-menu]')) {
        return;
      }

      const isOpen = menu.classList.contains('opacity-100');
      closeAllDropdowns(trigger);

      if (!isOpen) {
        menu.classList.remove('opacity-0', 'invisible', 'translate-y-1', 'pointer-events-none');
        menu.classList.add('opacity-100', 'visible', 'translate-y-0', 'pointer-events-auto');
        trigger.setAttribute('aria-expanded', 'true');
      } else {
        menu.classList.add('opacity-0', 'invisible', 'translate-y-1', 'pointer-events-none');
        menu.classList.remove('opacity-100', 'visible', 'translate-y-0', 'pointer-events-auto');
        trigger.setAttribute('aria-expanded', 'false');
      }
    });
  });

  document.addEventListener('click', () => closeAllDropdowns());

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeAllDropdowns();
    }
  });
}